import * as R from 'ramda';

export default function EditMasterVendorDialogController(
  $rootScope,
  $scope,
  alerts,
  ssDialogService,
  loaderService,
  vmDataService
) {
  const vm = this;
  vm.handleCloseDialogClick = handleCloseDialogClick;
  vm.handleAddMasterVendorFormSubmit = handleAddMasterVendorFormSubmit;
  vm.newMasterVendor = R.clone($scope.editMasterVendorDialogVM.masterVendor);

  /** **********************************
   * Event Handlers
   */

  function handleCloseDialogClick() {
    _closeDialog();
  }

  function handleAddMasterVendorFormSubmit() {
    _saveMasterVendor();
  }

  /** **********************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.editMasterVendorDialog);
  }

  function _saveMasterVendor() {
    if ($scope.vmaEditMasterVendorForm.$valid) {
      loaderService.showViewLoader = true;
      vmDataService.saveMasterVendor(vm.newMasterVendor)
        .then((response) => {
          if (!response.data) {
            alerts.error('Error occurred while saving the Master Vendor.');
          } else {
            alerts.success('The Master Vendor has been saved successfully.');
            // TODO: rewrite this to the new way of pushing persisted changes to the UI using the newMasterVendor
            $rootScope.$broadcast('refreshVMAVendors');
            loaderService.showViewLoader = false;
            ssDialogService.hide(ssDialogService.dialogs.vendorManagement.editMasterVendorDialog);
          }
        });
    }
  }
}

EditMasterVendorDialogController.$inject = [
  '$rootScope',
  '$scope',
  'alerts',
  'ssDialogService',
  'loaderService',
  'vmDataService',
];
